import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

interface LineItemsTechnicalNameQuestionBubbleProps {
  // Some UN numbers carry TDG special provision 16, which makes the technical
  // name mandatory. The tooltip has to say so rather than call it optional.
  required?: boolean;
}

export function LineItemsTechnicalNameQuestionBubble({
  required = false,
}: LineItemsTechnicalNameQuestionBubbleProps) {
  return (
    <Tooltip
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">
            {required ? "Technical Name" : "(Optional) Technical Name"}
          </T>
          <T size="xs" color="secondary">
            {required
              ? "This UN number requires a technical name. Consult your MSDS data sheets for the goods you are shipping and enter it here"
              : "Consult your MSDS data sheets for the goods you are shipping and enter the technical name, if applicable"}
          </T>
        </Stack>
      }
    />
  );
}
